import React from 'react';
import DataListAndSearch from '../../components/DataListAndSearch.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import RetIvaStore from '../../reflux/stores/RetIvaStore';
import RetIvaActions from '../../reflux/RetIvaActions';
import AlertActions from '../../reflux/AlertActions';
import _ from 'underscore';
import Delete from 'material-ui/svg-icons/action/delete-forever';

export default class RetIvaIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            retIvas: [],
            count:0,
        };

       	this.handleDelete = this.handleDelete.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.retIvaStoreChange = this.retIvaStoreChange.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSend = this.handleSend.bind(this);
    }

    
    componentWillMount() {
        AlertActions.configureAppBar('Retenciones de I.V.A.', null);
        RetIvaActions.getRetIvas();
        AlertActions.startLoading();
    }
    
    componentDidMount() {
        this.unsubscribe = RetIvaStore.listen(this.retIvaStoreChange);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }
    
    /**
     * Handles chanes in RetIvaStore
     * 
     * @param {string} e The event that was fired
     * @param {Array.<Retiva>} retivas A Collection of RetIva Objects
     * 
     */
    retIvaStoreChange(e, retivas, count) {
        if (e === 'getRetivas')
            this.setState({retIvas: retivas, count:count});
        if (e === 'filter')
            this.setState({retIvas: retivas});
        if (e === 'mail-sent') {
            const sent = (
                <p><img src="/public/images/mail-sent.gif" alt=""/></p>
            );

            const msg = (
                <div>
                    <p>Ha enviado el comprobante de retencion de I.V.A. con el N° {retivas.numeroRet} perteneciente a {retivas.proveedor.name} a la direccion de email: {retivas.proveedor.email}</p>
                    {sent}
                </div>
            );
            AlertActions.alert('open', 'Comprobante enviado por email', msg);
        }
        if (e === 'deleteRetIva') {
            const msg = <div>Retención de I.V.A. Eliminada  <Delete color="grey" /></div>;
            AlertActions.alert('open', msg, 'Ha eliminado satisfactoriamente la retención de I.V.A. N° '+retivas.numeroRet+' perteneciente a '+retivas.proveedor.name);
        }

            
    }

    /**
     * Handles search according to query received from TextField
     * 
     * @param {event} e TextField in which the query is being typed
     * 
     */
    handleSearch(q) {
        AlertActions.startLoading();
        RetIvaActions.apiFilter(q);
    }

    handleEdit(index) {
        const retIva = this.state.retIvas[index];
        this.props.router.push('retiva/edit/'+retIva.id);
    }

    /**
     * Handles deletion of a record
     * 
     * @param {number} del The index/id of the record to delete from the list
     */
    handleDelete(del) {
        let retIva = this.state.retIvas[del];
        RetIvaActions.deleteRetIva(retIva);
    }

    handleDownload(item, e) {
        const retiva = this.state.retIvas[item];
        RetIvaActions.download(retiva.id);
    }

    handleSend(index, e) {
        const retIva = this.state.retIvas[index];
        RetIvaActions.sendMail(retIva.id);
    }

    render() { 
        let LoadMore = 
        this.state.count === this.state.retIvas.length
        ? null
        : (
            <div className="center">
                <RaisedButton
                    onTouchTap={() => {RetIvaActions.getRetIvas(8); AlertActions.startLoading();}} 
                    className="center" 
                    label="Cargar Mas..." 
                    secondary={true} />
            </div>
        );

        return (
            <div className="retivacontainer">                
                <DataListAndSearch
                        sendMail={true}
                        handleSend={this.handleSend}
                        searchMargin="0px 5px"
                        style={{marginTop:35}}
                        searchTitle="Lista de Retenciones de I.V.A."
                        useCard={true}
                        onChangeInput={this.handleSearch}
                        inputPlaceHolder="Buscar retención"
                        criterios="N° de comprobante, nombre o rif del proveedor."
                        items={this.state.retIvas}
                        count={this.state.count}
                        handleEdit={this.handleEdit}
                        handleDelete={this.handleDelete}
                        rightButtonUseThis={false}
                        addButtonLink="/retiva/create"
                        resourceName="retención de I.V.A."
                        showAddButton={true}
                        download={true}
                        handleDownload={this.handleDownload}/>
                <div className="center" style={{marginBottom:10}}>Mostrando {this.state.retIvas.length} de {this.state.count} retenciones...</div>
                
                {LoadMore}

            </div>
            );
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/RetIva/RetIvaIndex.jsx
 **/